import { MenuItem } from '@headlessui/react'
import React, { useState } from 'react'
import { FaCaretDown, FaWhatsapp } from 'react-icons/fa'
import { MyLink } from '../MyLink'
import { whatsAppDisplay, whatsAppUrl } from 'utils/business-info'

// Mobile counterpart of SegmentNavBar (NavDropdown.js): a segment menu from
// data (utils/market-nav.js), with the markup and classes of the Singapore
// AirconNavBarSmall / TrainerNavBarSmall.

const MobileDropdown = ({ label, items }) => {
    const [isExpanded, setIsExpanded] = useState(false)
    const id = `segment-menu-${label.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`
    return (
        <li>
            <div className="flex justify-center">
                <button
                    type="button"
                    onClick={() => setIsExpanded(!isExpanded)}
                    className="flex justify-center items-center px-2 py-2 text-orange-600"
                    aria-expanded={isExpanded}
                    aria-controls={id}
                    aria-haspopup="true"
                >
                    {label} <FaCaretDown className="h-5 w-5 ml-1" />
                </button>
            </div>
            {isExpanded && (
                <ul id={id} role="menu" className="relative">
                    {items.map((item) => (
                        <MenuItem key={item.href} role="menuitem">
                            <MyLink href={item.href} prefetch={false} className="text-orange-500 text-sm p-2 block">
                                {item.label}
                            </MyLink>
                        </MenuItem>
                    ))}
                </ul>
            )}
        </li>
    )
}

export const SegmentNavBarSmall = ({ items }) => (
    <>
        {items.map((item) => {
            if (item.type === 'dropdown') return <MobileDropdown key={item.label} label={item.label} items={item.items} />
            if (item.type === 'link') {
                return (
                    <MenuItem key={item.href}>
                        <MyLink href={item.href} prefetch={false} className="flex justify-center px-2 py-2 text-orange-600" aria-label={item.ariaLabel}>
                            {item.label}
                        </MyLink>
                    </MenuItem>
                )
            }
            if (item.type === 'whatsapp') {
                return (
                    <MenuItem key="whatsapp" as="li">
                        <div className="flex justify-center pb-3">
                            <a
                                href={`${whatsAppUrl}?text=${encodeURIComponent(item.text)}`}
                                target="_blank"
                                rel="noreferrer"
                                aria-label={item.ariaLabel}
                                className="flex items-center gap-2 bg-linear-to-tr from-green-700 to-green-500 text-white text-sm font-bold px-5 py-2.5 rounded-full shadow-lg"
                            >
                                <FaWhatsapp className="text-base" />
                                {item.label ?? `WhatsApp ${whatsAppDisplay}`}
                            </a>
                        </div>
                    </MenuItem>
                )
            }
            return null
        })}
    </>
)
